import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { getEmailTemplateByNameAsync, sendEmailWithAttachmentAsync } from './sendemailThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const sendEmailSlice = createSlice({
    name: 'sendEmail',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(sendEmailWithAttachmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(sendEmailWithAttachmentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.apiError = undefined;
        })
            .addCase(sendEmailWithAttachmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getEmailTemplateByNameAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getEmailTemplateByNameAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(getEmailTemplateByNameAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default sendEmailSlice.reducer;
